module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_6.8e03ec1e.png";